<section *ngIf="notification" [ngClass]="getUnreadClass()">

  <ng-container *ngIf="!isCompactMode; else elseTemplate">
    <div class="row" (click)="onClickNotification(notification)">
      <div class="col-1 p-0">
        <div class="dot-container">
          <div class="dot" *ngIf="!notification.alreadyRead"></div>
        </div>
      </div>
      <div class="col-3 p-0">
        <div class="title">

          <div class="user-container">

            <div class="box ">
              <div class="letters-user bg-button "> {{ getLetters() }} </div>
            </div>
            <div class="summary">
              <div ellipsis [ellipsis-content]="notification.user!" [ngClass]="getTextReadClass()"> </div>
            </div>

          </div>

        </div>
      </div>
      <div class="col-2 p-0">
        <div class="type"  ellipsis [ellipsis-content]="notification.type!" [ngClass]="getTextReadClass()"></div>
      </div>
      <div class="col-5 p-0">
        <div class="description" ellipsis [ellipsis-content]="notification.reason!" [ngClass]="getTextReadClass()"> </div>
      </div>
      <div class=" date col-1 p-0">
       {{ getDate() }}
      </div>
    </div>
  </ng-container>


  <ng-template #elseTemplate>

    <ng-container *ngIf="notificationOfMenu">
      <div class="minimal row" (click)="onClickNotification(notification)">
        <div class="dot-container col-1 p-0">
          <div class="dot" *ngIf="!notification.alreadyRead"></div>
        </div>
        <div class="title col-9 pr-3"  ellipsis [ellipsis-content]="notification.title" [ngClass]="getTextReadClass()"></div>
        <div class="date col-1 p-0"> {{ getDate() }} </div>
      </div>
    </ng-container>


    <ng-container *ngIf="!notificationOfMenu">
      <div class="minimal row" (click)="onClickNotification(notification)">
        <div class="dot-container col-1 p-0">
          <div class="dot" *ngIf="!notification.alreadyRead"></div>
        </div>
        <div class="title col-3 p-0" [ngClass]="getTextReadClass()">
          {{ notification.title }} </div>
        <div class="col-2 p-0" >
          <div class="type"  ellipsis [ellipsis-content]="notification.type!" [ngClass]="getTextReadClass()"></div>
        </div>
        <div class="col-5 p-0">
          <div class="description" ellipsis [ellipsis-content]="notification.reason!" [ngClass]="getTextReadClass()"> </div>
        </div>
        <div class="date col-1 p-0"> {{ getDate() }} </div>
      </div>
    </ng-container>



  </ng-template>


</section>
